<template>
  <div class="customer-filter">
    <el-form :inline="true">
      <el-form-item label="商家">
        <tenantSelector
          size="small"
          ref="tenantSelector"
          v-model="searchForm.tenant"
        />
      </el-form-item>
      <el-form-item label="">
        <dateOptionSelector
          size="small"
          v-model="searchForm.dateTime"
          ref="dateOptionSelector"
          :options="dateOptions"
        />
      </el-form-item>
      <el-form-item label="商品">
        <el-input
          size="small"
          v-model="searchForm.product"
          style="width: 150px"
          placeholder="商品关键词.."
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="地区">
        <el-input
          size="small"
          v-model="searchForm.region"
          style="width: 150px"
          placeholder="地区关键词.."
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input
          size="small"
          v-model="searchForm.search"
          style="width: 300px"
          placeholder="单号/手机号/地址/姓名/备注.."
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>
  <script>
import dateOptionSelector from "@/components/dateOptionSelector";
import enumSelector from "@/components/enumSelector";
import tenantSelector from "@/components/tenantSelector";
export default {
  components: {
    enumSelector,
    dateOptionSelector,
    tenantSelector,
  },
  props: {
    status: {
      default: "",
    },
  },
  watch: {
    status: {
      handler(val) {
        this.searchForm.status = val;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      dateOptions: [{ value: "create", name: "下单时间" },{ value: "book", name: "预约时间" },{ value: "dispatch", name: "派单时间" },{ value: "complete", name: "完成时间" },{ value: "balance", name: "结算时间" }],
      searchForm: {
        search: "",
        tenant: "",
        status: "",
        source: "",
        region:"",
        product:"",
        dateTime: {
          dateType: "create",
          date: [],
        },
      },
    };
  },
  methods: {
    getfilter() {
      let filters = {
        tenant: this.searchForm.tenant ? this.searchForm.tenant.Key : "",
        search: this.searchForm.search,
        status: this.searchForm.status,
        region:this.searchForm.region,
        product:this.searchForm.product,
        source: this.searchForm.source,
        dateType: this.searchForm.dateTime.dateType,
        beginDate:
          this.searchForm.dateTime.date.length > 0
            ? this.searchForm.dateTime.date[0]
            : "",
        endDate:
          this.searchForm.dateTime.date.length > 1
            ? this.searchForm.dateTime.date[1]
            : "",
      };
      return filters;
    },
  },
  mounted() {},
};
</script>
  <style lang='scss' scoped>
/deep/.el-form-item {
  margin-bottom: 10px;
}
</style>